// import Vue from "vue";
import { reactive } from 'vue';
import { translation, translateToEn } from '@/plugins/i18n';
// import { transferMoney } from 'common/utils';
import trackings from '@/aspects/trackings';
import query from 'query-string';
import _ from "lodash";
import { priceByMonth, transferMoney } from '@/utils/money';
import { getCurrency } from '@/utils/currency';
import { flowTypes, pageConfig } from '@/common/service/page-config';
import { ZmLoading } from '@zoom/zoom-ui-vue3'
import globalEventBus from '@/common/global-event-bus';
import { isMobile, isTablet, isDesktop, isMobileInClient, isTabletInClient, isDesktopInClient } from '@/utils/responsive';
import { SHARE_TYPE_ENUM } from '@/views/config/shopping-cart/share-link.vue';
import { routePathMap } from '@/router/constant';
import {
  BASE_PLAN_SUB_TYPES,
  MODAL_TITLE_BACK_CLOSE_PAGE_FROMS,
  PageTypes,
  URL_PARAM_SETTING_DESIGN,
  URL_VALUE_SETTING_DESIGN_V2,
} from '@/common/constants.js'
import { $cookie } from '@/common/utils'
import AltIosNativeSelect from "@/components/alt-ios-native-select";
import { isEmptyVal } from '@/utils/index';
import { modalHybrid } from '@/utils/modal-utils.js';
import { modalPopLink, interceptLink } from './directives';
import mitt from 'mitt';

const bus = mitt();

const isModal = pageConfig.pageType === PageTypes.modal;

const isBasic2ProInClient = () => {
  return modalHybrid.isInWebview &&
    isModal &&
    pageConfig.type === flowTypes.basic2pro
}

const isSimplify = String(pageConfig.simplify ?? '') === 'true';
const isModalDelta =
  isModal && pageConfig?.addQty > 0 && pageConfig.type === flowTypes.edit;
const isAlign = pageConfig.type === flowTypes.align;
const pageFrom = String(pageConfig.pageFrom ?? '');

let loader;

export const $query = query.parse(location.search);

export const $tracking = trackings;

export const $config = (key, def) => {
    return _.get(pageConfig || {}, key, def);
};

const isEducation = () => {
  const { init_categories } = pageConfig;
  let categories = init_categories ? init_categories.split(';') : [];
  return pageConfig.plan === BASE_PLAN_SUB_TYPES.EDUCATION || categories.includes(BASE_PLAN_SUB_TYPES.EDUCATION);
}

// Initialize $context before install
const isUpsell = pageConfig.type === flowTypes.upsell || (pageConfig.dpid && [flowTypes.edit, flowTypes.add2cart].includes(pageConfig.type));

export let $context = {
    flow: pageConfig.type, // flow type
    type: pageConfig?.editConfig?.planType, // current config plan type
    pageType: pageConfig?.pageType ?? PageTypes.normal,
    pageFrom,
    currency: getCurrency(),
    $on: globalEventBus.$on.bind(globalEventBus),
    $off: globalEventBus.$off.bind(globalEventBus),
    $emit: globalEventBus.$emit.bind(globalEventBus),
    is: {
        persistCart: false,
        // responsive mobile/tablet/desktop
        mobile: isBasic2ProInClient() ? isMobileInClient : isMobile,
        tablet: isBasic2ProInClient() ? isTabletInClient : isTablet,
        desktop: isBasic2ProInClient() ? isDesktopInClient : isDesktop,
        modal: isModal,
        modalTitleBackClose: MODAL_TITLE_BACK_CLOSE_PAGE_FROMS.includes(pageFrom),
        modal2Column:
          isModal &&
          String(pageConfig[URL_PARAM_SETTING_DESIGN] ?? '') === URL_VALUE_SETTING_DESIGN_V2 &&
          !isSimplify &&
          !isModalDelta &&
          !isAlign,
        simplify: isSimplify,
        // session
        loggedIn: window.SB?.loggedIn ?? false,
        // page mode
        embedded: false, // launched in iframe or modal
        // flow
        buyNow: pageConfig.type === flowTypes.buyNow,
        // FREE TRIAL
        add2trial: pageConfig.type === flowTypes.add2trial,
        // BUY TRIAL
        buyTrial: pageConfig.type === flowTypes.buyTrial,
        add2cart: pageConfig.type === flowTypes.add2cart && !isUpsell,
        basic2pro: pageConfig.type === flowTypes.basic2pro,
        pro2biz: pageConfig.type === flowTypes.pro2biz,
        edit: pageConfig.type === flowTypes.edit && !isUpsell,
        upsell: isUpsell,
        edu: isEducation(),
        // edit flow of delta view
        delta: pageConfig.preloadCartInfo?.configData?.type === SHARE_TYPE_ENUM.ADD_QTY && pageConfig.type === flowTypes.edit,
        modalDelta: isModalDelta,
        addQty: pageConfig?.addQty > 0, // from add qty params
        upgrade: pageConfig.type === flowTypes.upgrade,
        downgrade: pageConfig.type === flowTypes.downgrade,
        trial2paid: pageConfig.type === flowTypes.trial2paid,
        mixBuy: pageConfig.type === flowTypes.mixBuy,
        pro2bundle: pageConfig.type === flowTypes.pro2bundle,
        biz2bundle: pageConfig.type === flowTypes.biz2bundle,
        prop2bundle: pageConfig.type === flowTypes.prop2bundle,
        pro2prop: pageConfig.type === flowTypes.pro2prop,
        zs2ze: pageConfig.type === flowTypes.zs2ze,
        esc2escp: pageConfig.type === flowTypes.esc2escp,
        edu2esc: pageConfig.type === flowTypes.edu2esc,
        switch: pageConfig.type === flowTypes.switch,
        switchCurrency: pageConfig.type === flowTypes.switchCurrency,
        sdkpayg2uc: pageConfig.type === flowTypes.sdkpayg2uc,
        billingBasicPlusOffer: /^billingBasicPlusOffer$/i.test(pageConfig.ref),
        billingGetOffer: /^billingGetOffer$/i.test(pageConfig.ref),
        pbx2prop: pageConfig.type === flowTypes.pbx2prop,
        winback: /^winback$/i.test(pageConfig.ref),
        isFreeWinback: /^winback$/i.test(pageConfig.ref) && pageConfig.type === flowTypes.basic2pro,
        biz2pro: pageConfig.type === flowTypes.biz2pro,
        align: isAlign,
        /* functions will be rewritten as getter, see ref0 */
        // account
        withCC: () => window.__rootApp__?.$store.getters.withCcAccount,
        bulkLicense: () => window.__rootApp__?.$store.getters.basicConfig?.isBulkLicenseAccount,
        // router
        configPage: () => window.__rootApp__?.$router?.currentRoute.value?.path === routePathMap.config,
        checkoutPage: () => window.__rootApp__?.$router?.currentRoute.value?.path === routePathMap.checkout,
        editPage: () => window.__rootApp__?.$router?.currentRoute.value?.path === routePathMap.edit,
        addPage: () => window.__rootApp__?.$router?.currentRoute.value?.path === routePathMap.add,
        mixPage: () => window.__rootApp__?.$router?.currentRoute.value?.path === routePathMap.mix,
        downgradePage: () => window.__rootApp__?.$router?.currentRoute.value?.path === routePathMap.downgrade,
        upgradePage: () => window.__rootApp__?.$router?.currentRoute.value?.path === routePathMap.upgrade,
        updateSuccessPage: () => window.__rootApp__?.$router?.currentRoute.value?.path === routePathMap.updateSuccess,
        addTrialSuccessPage: () => window.__rootApp__?.$router?.currentRoute.value?.path === routePathMap.addTrialSuccess,
        apmSuccessPage: () => window.__rootApp__?.$router?.currentRoute.value?.path === routePathMap.apmSuccess,
        successPage: () => window.__rootApp__?.$router?.currentRoute.value?.path === routePathMap.success,  
        // from marketing coupon
        fromCampaignLink: () => isEmptyVal(pageConfig?.marketingCoupon) === false,
        // from persistent cart
        fromPersistentCart: pageConfig?.persist_cart === "true",
        // from promo code and use marketing coupon (one promo code mapping multiple marketing coupons)
        fromPromoCodeCampaign: () => !isEmptyVal(pageConfig?.promoCampaignInfo),
    },
};

Object.keys($context.is).forEach(key => {
    // ref0
    if (typeof $context.is[key] === 'function') {
        Object.defineProperty($context.is, key, { get: $context.is[key] });
    }
});

let reactiveCampaignFlags;
if (window.campaignFlags && typeof window.campaignFlags === 'object') {
    reactiveCampaignFlags = reactive({ ...window.campaignFlags });
} else {
    reactiveCampaignFlags = reactive({});
}

if (window.campaignFlags && typeof window.campaignFlags === 'object') {
    window.reactiveCampaignFlags = new Proxy(reactiveCampaignFlags, {
        set(target, prop, value) {
            target[prop] = value;
            if (window.campaignFlags) {
                window.campaignFlags[prop] = value;
            }
            return true;
        },
        get(target, prop) {
            return target[prop];
        }
    });
} else {
    window.reactiveCampaignFlags = reactiveCampaignFlags;
}

export const $isEnabled = (feature) => {
    return (window.reactiveCampaignFlags?.[feature] ?? window.campaignFlags?.[feature]) === true;
}

// Assign all global variables to window before install
window.$tracking = $tracking;
window.$query = $query;
window.$cookie = $cookie;
window.$config = $config;
window.$money = transferMoney;
window.$priceByMonth = priceByMonth;
window.$context = $context;
window.$isEnabled = $isEnabled;

export default {
    install(app) {

        app.component("alt-ios-native-select", AltIosNativeSelect);
        app.directive("modal-pop-link", modalPopLink);
        app.directive("intercept-link", interceptLink);

        /*
        // polyfill for Vue3 app instance so that we don't have to change anything below
        Vue = new Proxy(Vue, {
            get(obj, prop){
                if(prop == 'prototype'){
                    return obj.config.globalProperties
                }
                return obj[prop]
            },
            set(obj, prop, value){
                if(prop == 'prototype'){
                    obj.config.globalProperties = value;
                }else{
                    obj[prop] = value
                }
            }
        })
        */

        app.config.globalProperties.$t = translation;
        // Wrapper for translateToEn to make $tEn consistent with $t calling convention
        // $t uses spread params, translateToEn expects array
        app.config.globalProperties.$tEn = (key, ...params) => {
            return translateToEn(key, params?.length > 0 ? params : []);
        };

        app.config.globalProperties.$tracking = $tracking;

        app.config.globalProperties.$query = $query;

        app.config.globalProperties.$cookie = $cookie;

        app.config.globalProperties.$loading = window.$loading = (is = true) => {
            if (is) {
                let text = '';
                if (typeof is === 'string') {
                    text = is;
                }
                loader && loader.close();
                loader = ZmLoading.create({
                    text,
                    customClass: 'opc-global-loading',
                })
            } else if (is === false) {
                loader.close();
            }
            return loader
        };

        app.config.globalProperties.$config = $config;

        app.config.globalProperties.$campaignFlags = window.campaignFlags;
        app.config.globalProperties.$reactiveCampaignFlags = window.reactiveCampaignFlags;
        app.config.globalProperties.$isEnabled = $isEnabled;

        app.config.globalProperties.$money = transferMoney;
        app.config.globalProperties.$priceByMonth = priceByMonth;

        app.config.globalProperties.$context = $context;

        app.config.globalProperties.$on = bus.on.bind(bus);
        app.config.globalProperties.$off = bus.off.bind(bus);
        app.config.globalProperties.$emit = bus.emit.bind(bus);
    }
};
